import { db } from '../config/firebase';
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  limit,
  serverTimestamp
} from 'firebase/firestore';

/**
 * Coleções do Firestore
 */
const LINK_HISTORY_COLLECTION = 'link_history';

/**
 * Registra um novo link gerado no histórico
 * @param {string} link - O link gerado
 * @param {string} courseName - Nome do projeto
 * @param {string} userId - ID do usuário
 * @param {string} email - Email do usuário (opcional)
 * @param {boolean} isScorm - Indica se é um pacote SCORM (opcional)
 * @returns {Promise<Object>} Resultado da operação
 */
export const saveGeneratedLink = async (link, courseName, userId, email = null, isScorm = false) => {
  try {
    // console.log('Tentando salvar link no histórico:', { link, courseName, userId, email, isScorm });

    const linkData = {
      link,
      courseName,
      userId,
      email: email || null,
      isScorm: isScorm,
      createdAt: serverTimestamp(),
      generatedAt: serverTimestamp() // Para manter compatibilidade com o nome antigo
    };

    // console.log('Dados do link antes de salvar:', linkData);

    const docRef = await addDoc(collection(db, LINK_HISTORY_COLLECTION), linkData);

    // console.log('Link salvo com sucesso! ID:', docRef.id);

    return {
      success: true,
      id: docRef.id,
      message: 'Link salvo com sucesso!',
      linkId: docRef.id
    };
  } catch (error) {
    console.error('Erro ao salvar link gerado:', error);
    return {
      success: false,
      message: 'Erro ao salvar link: ' + error.message
    };
  }
};

/**
 * Obtém o histórico de links gerados
 * @param {number} maxResults - Número máximo de resultados (padrão: 1000)
 * @returns {Promise<Array>} Lista de links gerados
 */
export const getLinkHistory = async (maxResults = 1000) => {
  try {
    const linksRef = collection(db, LINK_HISTORY_COLLECTION);
    const q = query(
      linksRef,
      orderBy('createdAt', 'desc'),
      limit(maxResults)
    );

    const querySnapshot = await getDocs(q);
    const links = [];

    querySnapshot.forEach((doc) => {
      links.push({
        id: doc.id,
        ...doc.data()
      });
    });

    return links;
  } catch (error) {
    console.error('Erro ao buscar histórico de links:', error);
    return [];
  }
};

export default {
  saveGeneratedLink,
  getLinkHistory
};